module.exports = __webpack_public_path__ + "img/set-conference-day1-infographic.71d78052.png";